module.exports = __webpack_public_path__ + "static/img/gy.53f13f7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/gy.png
// module id = Zzzk
// module chunks = 1